/**
 * Список образовательных услугу для УФТТ 3.0
 */
import { Pagination } from '@n3/ng-api-common';
import { EducationServiceShort } from './educationServiceShort.model';
export class EducationServiceList extends Pagination {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: EducationServiceShort[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new EducationServiceShort(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
